import { Facade } from "./facade";
import { AlertController } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { AppFacade } from "../services/app-facade/app-facade.service";
import { getErrorMessage } from "../util/get-error-message";

export class AlertFacade extends Facade {

    constructor(
        protected appFacade: AppFacade,
        protected alertController: AlertController,
        protected translateService: TranslateService
    ) {
        super(appFacade);
    }

    yesNo(title: string, message?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.alertController.create({
                title: this.translateService.instant(title),
                message: message ? this.translateService.instant(message) : undefined,
                cssClass: `alert-message-key-${message}`,
                buttons: [
                    {
                        text: "Yes",
                        handler: () => {
                            resolve();
                        }
                    },
                    {
                        text: "No",
                        handler: () => {
                            reject();
                        }
                    }
                ]
            }).present();
        });
    }

    ok(title: string, message?: string | Error): Promise<any> {

        message = getErrorMessage(message);

        const messageKey = message.toLowerCase().replace(/[^a-z^\.^-]/g, "");

        return new Promise((resolve, reject) => {
            this.alertController.create({
                title: this.translateService.instant(title),
                message: message ? this.translateService.instant(message as string) : undefined,
                cssClass: `alert-message-key-${messageKey}`,
                buttons: [{
                    text: "Ok",
                    handler: () => {
                        resolve();
                    }
                }]
            }).present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/alert-facade.ts